export default {
  inject: {
    mapHandle: {},
  },
  methods: {
    fitBounds(value) {
      if (!this.mapHandle || !this.mapHandle.fitBounds) return
      this.mapHandle.fitBounds(value)
    },
  },
}
